<template>
  <div :style="{maxHeight: 'calc(100vh - 90px)'}">
    <div class="right" :style="{borderLeft: '1px solid #CACACA', height: 'calc(100vh - 90px)'}">
      <div>
        折抵活動
        <Select1 :defaultValue="area" @input="area=$event;addnew=false;itemSelected=null" :width="'350px'">
          <option :value="null">全部</option>
          <option v-for="(rest, r) in restaurants" :key="`rest-${r}`" :value="rest" >{{rest}}</option>
        </Select1>
        <RadioTop :options="['全部', '進行中', '過期', '未來']" :defaultValue="filter" @input="filter=$event"/>
        <RBtn @click="edit=true" :bg="'var(--color-pri)'" :icon="'add'" :text="'新增優惠折扣'" :style="{marginLeft: 'auto'}"/>
        <template  v-if="draggable">
        <AddBtn @click="draggable=false;getdata()" :bg="'#B9B9B9'" :text="'取消'"/>
        <AddBtn @click="saveSort" :bg="'var(--highlight)'" :text="'儲存排序'" :icon="'sort'"/>
        </template>
        <AddBtn @click="draggable=true" v-else :bg="'var(--point)'" :text="'編輯排序'" :icon="'sort'"/>
      </div>
      <div>
      <Table @sort="rows=$event" :rows="rows" :draggable="draggable">
        <template slot="slot_head">
          <th :style="{textAlign: 'start', width: '90px'}">自動</th>
          <th :style="{textAlign: 'start', width: '100px'}">狀態</th>
          <th :style="{textAlign: 'start', width: 'inherit'}">折扣名稱</th>
          <th :style="{textAlign: 'start', width: 'inherit'}">條件/折扣</th>
          <th :style="{textAlign: 'start', width: '200px'}">適用區域</th>
          <template v-if="area">
            <th :style="{textAlign: 'center', maxWidth: '400px'}">線上</th>
          </template>
          <template v-else>
            <th v-for="rest in restaurants" :key="`online-${rest}`" :style="{textAlign: 'center', maxWidth: '400px'}">線上<br>{{rest}}</th>
          </template>
          <th :style="{textAlign: 'start', width: '130px'}">起</th>
          <th :style="{textAlign: 'start', width: '130px'}">迄</th>
          <th>修改優惠</th>
          <th>清除</th>
        </template>
        <tr slot-scope="{item, index}" :style="{height: '100px', border: 'none', position:'relative'}">
          <td :style="{textAlign: 'start'}"><div class="auto" v-if="item.auto" :title="(item.target_tags || []).join('|')"></div></td>
          <td :style="{textAlign: 'start'}">{{status(item)}}</td>
          <td :style="{textAlign: 'start'}">{{item.name}}</td>
          <template><td :style="{textAlign: 'start'}" v-if="item.mode===1">滿額折抵  {{item.cond}}元折{{item.disc}}元</td>
          <td :style="{textAlign: 'start'}" v-else-if="item.mode===2">滿額折抵(累進)  每{{item.cond}}元折{{item.disc}}元</td>
          <td :style="{textAlign: 'start'}" v-else-if="item.mode===3">滿額折扣  滿{{item.cond}}元打{{item.disc}}折</td>
          <td :style="{textAlign: 'start'}" v-else-if="item.mode===4">
            <div :style="{display: 'flex', gap: '1em'}">
              <div>指定商品</div>
              <div>折 <span :style="{display: 'inline-flex', justifyContent: 'flex-end', minWidth: '2em'}">{{item.disc}}</span> 元</div>
              <div class="note" @click="view=[...item.specify, ...item.specify_set];viewExclude=item.exclude"/>
            </div>
          </td>
          <td :style="{textAlign: 'start'}" v-else-if="item.mode===8">
            <div :style="{display: 'flex', gap: '1em'}">
              <div>指定商品滿{{item.disc}}</div>
              <div>折 <span :style="{display: 'inline-flex', justifyContent: 'flex-end', minWidth: '2em'}">{{item.disc}}</span> 元</div>
              <div class="note" @click="view=[...item.specify, ...item.specify_set];viewExclude=item.exclude"/>
            </div>
          </td>
          <td :style="{textAlign: 'start'}" v-else-if="item.mode===5">
            <div :style="{display: 'flex', gap: '1em'}">
              <div>指定商品</div>
              <div>打 <span  :style="{display: 'inline-flex', justifyContent: 'flex-end', minWidth: '2em'}">{{item.disc}}</span> 折</div>
              <div class="note" @click="view=[...item.specify, ...item.specify_set];viewExclude=item.exclude"/>
            </div>
          </td>
          <td :style="{textAlign: 'start'}" v-else-if="item.mode===7">
            <div :style="{display: 'flex', gap: '1em'}">
              <div>全部指定商品</div>
              <div>折 <span :style="{display: 'inline-flex', justifyContent: 'flex-end', minWidth: '2em'}">{{item.disc}}</span> 元</div>
              <div class="note" @click="view=[...item.specify, ...item.specify_set];viewExclude=item.exclude"/>
            </div>
          </td>
          <td :style="{textAlign: 'start'}" v-else-if="item.mode===6">
            <div :style="{display: 'flex', gap: '1em'}">
              <div>[{{item.ID}}] {{item.disc ? `${item.disc}元` : '非固定金額'}}</div>
            </div>
          </td>
          <td :style="{textAlign: 'start'}" v-else></td>
          </template>
          <td :style="{textAlign: 'start', maxWidth: '400px'}">
            <div :style="{display: 'flex', gap: '.5em', flexWrap: 'wrap', lineHeight: '1em', height: '100%', alignItems:'center'}" v-html="(item.store||[]).map(e => `<span>${e}</span>`).join(' / ')"/>
          </td>
          <template v-if="area">
            <td :style="{textAlign: 'center', maxWidth: '400px'}">
              <button class="pos" :class="(item.online || []).includes(area) ? 'able' : ''"  v-if="item.store.includes(area)"
            @click="saveOnline(item._id, (item.online || []).includes(area) ? Array.from(new Set(item.online.filter(e => e !== area))) : [...(item.online || []), area], index)"></button>
          </td>
          </template>
          <template v-else>
          <td :style="{textAlign: 'center', maxWidth: '400px'}"  v-for="rest in restaurants" :key="`online-value-${rest}`">
            <button class="pos" :class="(item.online || []).includes(rest) ? 'able' : ''"  v-if="item.store.includes(rest)"
            @click="saveOnline(item._id, (item.online || []).includes(rest) ? Array.from(new Set(item.online.filter(e => e !== rest))) : [...(item.online || []), rest], index)"></button>
          </td>
          </template>
          <!-- <td :style="{textAlign: 'start'}">{{item.store}}</td> -->
          <td :style="{textAlign: 'start', fontSize: '18px'}">
              <div :style="{whiteSpace: 'nowrap', fontSize: '18px'}">{{moment(item.startTime).format('yyyy-MM-DD')}}</div>
              <div>{{moment(item.startTime).format('HH:mm')}}</div>
          </td>
          <td :style="{textAlign: 'start', fontSize: '18px'}">
              <div :style="{whiteSpace: 'nowrap', fontSize: '18px'}">{{moment(item.expireTime).format('yyyy-MM-DD')}}</div>
              <div>{{moment(item.expireTime).format('HH:mm')}}</div>
          </td>
          <td>
            <button v-if="item.mode===6&&item.disc===0" :style="{backgroundColor:'#FFFFFF'}"  @click="setItemERP(item)">
              <svg data-v-22b0bf74="" data-v-7e8e57ba="" width="30" height="32" viewBox="0 0 30 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.4561 5.26736H2.10517C0.947432 5.26736 0 6.21556 0 7.37422V29.4973C0 30.6559 0.947432 31.6041 2.10517 31.6041H22.4561C23.6138 31.6041 24.5613 30.6559 24.5613 29.4973V7.37422C24.5613 6.21556 23.6138 5.26736 22.4561 5.26736ZM21.7541 28.7947H2.80717V8.07636H21.7541V28.7947Z" fill="var(--color-pri)"></path><path data-v-22b0bf74="" data-v-7e8e57ba="" d="M5.43874 2.10686C5.43874 0.948192 6.38617 0 7.5439 0H27.8948C29.0526 0 30 0.948192 30 2.10686V24.2295C30 25.3882 29.0526 26.3363 27.8948 26.3363H27.1928V2.80943H5.43874V2.10686Z" fill="var(--color-pri)"></path><path data-v-22b0bf74="" data-v-7e8e57ba="" d="M6.4911 14.0463C6.4911 13.4667 6.96482 12.9931 7.5439 12.9931H17.0174C17.5964 12.9931 18.0697 13.4672 18.0697 14.0463V14.7484C18.0697 15.328 17.596 15.8021 17.0174 15.8021H7.5439C6.96482 15.8021 6.4911 15.328 6.4911 14.7484V14.0463ZM6.4911 20.8941C6.4911 20.3146 6.96482 19.8405 7.5439 19.8405H13.8598C14.4389 19.8405 14.9122 20.3146 14.9122 20.8941V21.5963C14.9122 22.1758 14.4385 22.6495 13.8598 22.6495H7.5439C6.96482 22.6495 6.4911 22.1754 6.4911 21.5963V20.8941Z" fill="var(--color-pri)"></path></svg>
            </button>
            <EditBtn v-else-if="item.mode===6&&item.disc!==0 " @click="setItemERP(item)" :style="{margin: 'auto'}"/>
            <EditBtn v-else @click="setItem(item)" :style="{margin: 'auto'}"/>
          </td>
          <td><DelBtn @click="deleteItem={_id: item._id, index, name: item.name}" :style="{margin: 'auto'}"/></td>
        </tr>
      </Table>
      </div>
    </div>
    <DialogDef2 :show="edit" @close="clear" :label="'優惠折扣'" :style="{top: '90px'}">
      <div class="editDiscount" :style="{padding: '0 53px 30px', display: 'flex', flexDirection: 'column', gap: '15px', maxWidth: '820px', margin: '26px 10px', maxHeight: '65vh', overflowY: 'auto'}">
        <div class="field"><div :style="{whiteSpace: 'nowrap'}">優惠折扣類型</div></div>
        <!-- , '指定商品滿額折抵' -->
        <RadioTop class="leftRadio" :height="'60px'" :width="'211px'" :options="['滿額折抵', '滿額折抵(累進)', '滿額折扣', '指定商品折抵', '指定商品折扣', '全部指定商品折抵']"
        :defaultValue="mode" @input="mode=$event"/>
        <div class="field">
          <div>折扣名稱</div>
          <NormalInput :width="'560px'" :style="{height: '45px'}"
            :defaultValue="name" @input="name=$event"/>
        </div>
        <div class="field" v-if="mode==='滿額折扣'">
          <div>條件</div>
          <div :style="{display: 'flex', gap: '10px', lineHeight: '40px'}">
            <span>消費滿</span>
            <NormalInput :width="'113px'" :defaultValue="cond" @input="cond=parseInt($event)" :center="true"/>
            <span>元，打</span>
            <NormalInput :width="'113px'" :defaultValue="disc" @input="disc=parseInt($event)" :center="true"/>
            <span>折</span>
          </div>
        </div>
        <template v-else-if="mode==='指定商品折抵'">
        <div class="field" >
          <div>條件</div>
          <div :style="{display: 'flex', gap: '10px', lineHeight: '40px'}">
            <span>指定商品</span>
            <span>折扣</span>
            <NormalInput :width="'113px'" :defaultValue="disc" @input="disc=parseInt($event)" :center="true"/>
            <span>元</span>
          </div>
        </div>
        </template>
        <template v-else-if="mode==='全部指定商品折抵'">
        <div class="field" >
          <div>條件</div>
          <div :style="{display: 'flex', gap: '10px', lineHeight: '40px'}">
            <span>全部指定商品</span>
            <span>折扣</span>
            <NormalInput :width="'113px'" :defaultValue="disc" @input="disc=parseInt($event)" :center="true"/>
            <span>元</span>
          </div>
        </div>
        </template>
        <template v-else-if="mode==='指定商品折扣'">
        <div class="field" >
          <div>條件</div>
          <div :style="{display: 'flex', gap: '10px', lineHeight: '40px'}">
            <span>指定商品</span>
            <span>打</span>
            <NormalInput :width="'113px'" :defaultValue="disc" @input="disc=parseInt($event)" :center="true"/>
            <span>折</span>
          </div>
        </div>
        </template>
        <template v-if="mode==='指定商品折抵'||mode==='指定商品折扣'||mode==='全部指定商品折抵'||mode==='指定商品滿額折抵'">
          <div class="field">
            <div>指定形式</div>
            <RT :options="['包含',  '排除']" :defaultValue="exclude ? '排除' : '包含'" @input="exclude=($event !== '包含')"/>
          </div>
        <div class="field" >
          <div>指定商品</div>
          <div :style="{display: 'flex', gap: '10px', lineHeight: '40px', flexWrap: 'wrap', alignItems: 'flex-start',
          maxWidth: 'calc(100% - 118px)'}">
            <div v-for="(sp, s) in products.filter(e => specify.includes(e._id))"  :class="[sp.t, exclude&&'exclude']"
              class="specitem" :key="`specify-${s}`" @dblclick="specify.splice(s, 1)">{{sp.name}}</div>
            <div :style="{display: 'flex', gap: '10px'}">
              <AddBtn :text="'新增指定商品'" @click="specifys=JSON.parse(JSON.stringify(specify));addproduct=true"
              :style="{borderRadius: '3px', height: '50px', width: '211px', fontSize: '18px'}" :iconSize="30"
              :icon="'plusSqr'" :bg="'var(--color-pri)'"/>
            </div>
          </div>
        </div>
        </template>
        <div class="field 123" v-if="/滿額折抵/.test(mode)">
          <div>條件</div>
          <div :style="{display: 'flex', gap: '10px', lineHeight: '40px'}">
            <span>消費滿</span>
            <NormalInput :width="'113px'" :defaultValue="cond" @input="cond=parseInt($event)" :center="true"/>
            <span>元，折</span>
            <NormalInput :width="'113px'" :style="{color: 'var(--highlight)', fontWeight: 700}" :defaultValue="disc" @input="disc=parseInt($event)" :center="true"/>
            <span>元</span>
          </div>
        </div>
        <div class="field">
          <div>使用期限</div>
          <div v-if="editRange" :style="{display: 'flex', flexDirection: 'column', gap: '20px'}">
            <DateInput :inline="true" :style="{marginInline: '0 auto'}" :defaultValue="range" @input="updateRange"/>
            <SaveBtn @click="editRange=false" :style="{marginLeft: 'auto'}" :text="'確定'"/>
          </div>
          <div v-else :style="{display: 'flex', flexDirection: 'row', gap: '20px'}">
            <span v-if="range&&range.start&&range.end">{{range.start}} ~ {{range.end}}</span>
            <EditBtn @click="editRange=true"/>
          </div>
        </div>
        <div class="field">
          <div>適用區域</div>
          <CheckBox :defaultValue="store" @input="store=$event" :options="restaurants" :style="{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)'}"></CheckBox>
        </div>
        <div class="field">
          <div>自動套用</div>
          <div><switchVue :defaultValue="auto" @update="auto=$event"/></div>
        </div>
        <div class="field" v-if="auto">
          <div>套用條件</div>
          <div class="tags">
            <div class="tagsList" v-if="(tags||[]).length>0">
              <div v-for="(tag, t) in tags" :key="`tag-${t}`">{{tag}} <button class="close" @click="tags.splice(t, 1)"></button></div>
            </div>
            <div class="tagBtns" :style="{justifyContent:'flex-start'}">
              <Select1 :style="{width: '260px', margin: 0}" :defaultValue="vip" @input="vip=$event">
              <option disabled="" :value="null">請選擇會員群組</option>
              <option v-for="(vipTag, v) in vipTags" :key="`vipTag-${v}`" :value="vipTag.options">{{vipTag.options}}(成員:{{vipTag.sum}}人)</option>
            </Select1><button class="add" @click="tags.push(vip);vip=null"><div></div></button></div>
          </div>
        </div>
      </div>
      <Btns v-if="id" :align="'center'" :temp="'新增'" :style="{marginInline: 'auto', marginBottom: '39px'}" @save="update" @temp="add" @cancel="clear"/>
      <Btns v-else :align="'center'" :temp="'新增'" :style="{marginInline: 'auto', marginBottom: '39px'}" @save="add" @cancel="clear"/>
    </DialogDef2>
    <DialogDef2 v-if="editERP" :show="editERP" @close="clear" :label="editERP.ID + '_' + editERP.name" :style="{top: '90px'}">
      <div class="editDiscount" :style="{padding: '0 53px 30px', display: 'flex', flexDirection: 'column', gap: '15px', maxWidth: '820px', margin: '26px 10px', maxHeight: '65vh', overflowY: 'auto'}">
        <div class="field">
          <div>折扣名稱</div>
          <NormalInput :width="'560px'" :style="{height: '45px'}"
            :defaultValue="name" @input="name=$event"/>
        </div>
        <div class="field 123">
          <div>金額</div>
          <div v-if="!editERP.fixed" :style="{display: 'flex', gap: '10px', lineHeight: '40px'}">
            <NormalInput :width="'113px'" :style="{color: 'var(--highlight)', fontWeight: 700}" :defaultValue="disc" @input="disc=parseInt($event)" :center="true"/>
            <span>元</span>
          </div>
          <div v-else :style="{color: 'var(--highlight', fontSize: '28px', alignItems:'center', letterSpacing: '.1em'}">{{disc}} <span>元</span></div>
        </div>
        <div class="field">
          <div>使用期限</div>
          <div v-if="editRange" :style="{display: 'flex', flexDirection: 'column', gap: '20px'}">
            <DateInput :inline="true" :style="{marginInline: '0 auto'}" :defaultValue="range" @input="updateRange"/>
            <SaveBtn @click="editRange=false" :style="{marginLeft: 'auto'}" :text="'確定'"/>
          </div>
          <div v-else :style="{display: 'flex', flexDirection: 'row', gap: '20px'}">
            <span v-if="range&&range.start&&range.end">{{range.start}} ~ {{range.end}}</span>
            <EditBtn @click="editRange=true"/>
          </div>
        </div>
        <div class="field">
          <div>適用區域</div>
          <CheckBox :defaultValue="store" @input="store=$event" :options="restaurants" :style="{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)'}"></CheckBox>
        </div>
      </div>
      <Btns v-if="id" :align="'center'" :save="'儲存'" :style="{marginInline: 'auto', marginBottom: '39px'}" @save="updateERP" @cancel="clear"/>
      <Btns v-else :align="'center'" :save="'新增'" :style="{marginInline: 'auto', marginBottom: '39px'}" @save="addERP" @cancel="clear"/>
    </DialogDef2>
    <DialogDef2 :show="addproduct" :label="exclude ? '排除指定商品' : '指定商品'"  @close="addproduct=false;filCate=null;filText=null" :width="537" :haadBg="'#517FA4'">
      <div class="pointingProduct">
        <div class="fil">
          <Select :width="'200px'" :defaultValue="filCate" @input="filCate=$event" >
            <option :value="null">全部類別</option>
            <option v-for="({category}, c) in Sets" :key="`fil-category-${c}`" :value="category">{{category}}</option>
          </Select>
          <searchVue :width="'260px'" :defaultValue="filText" @input="filText=$event"/>
        </div>
        <div class="list">
          <div v-for="(setGroup, sg) in Sets"  :key="`sg-${sg}`" :label="setGroup.category">
            <template v-if="(!filCate||filCate===setGroup.category)">
              <div class="setTitle" v-if="!filText||setGroup.items.filter(({name}) => new RegExp(filText, 'ig').test(name)).length>0" :style="{fontWeight: '900'}"><button class="selectAll" @click="specifys=Array.from(new Set([...specifys, ...setGroup.items.map(e => e._id)]))" v-if="!filText">全選</button>{{setGroup.t==='single'?'-----':'====='}} {{setGroup.category}} {{setGroup.t==='single'?'-----':'====='}}</div>
              <template v-for="({_id, name, id, price}, s) in setGroup.items">
              <div class="setli" :key="`set-${s}`" v-if="!filText||new RegExp(filText, 'ig').test(name)">
                <label :for="_id">
                  <div class="checkbox" :class="[exclude&&'exclude', specifys.includes(_id)&&'checked']">
                    <input type="checkbox"  :value="_id" v-model="specifys" :id="_id">
                  </div>
                  {{id}} {{name}} <div :style="{marginLeft: 'auto'}">{{formatDollarInt(price)}}</div>
                </label>
              </div>
              </template>
            </template>
          </div>
        </div>
        <Btns @cancel="addproduct=false;filCate=null;filText=null" @save="specify=JSON.parse(JSON.stringify(Array.from(new Set(specifys))));addproduct=false;filCate=null;filText=null" :save="'確定'"/>
      </div>
    </DialogDef2>
    <DialogDef2 :show="view.length>0" :label="viewExclude ? '排除指定商品' : '指定商品'" :width="537" :haadBg="'#517FA4'" @close="view=[];filCate=null;filText=null">
      <div class="pointingProduct" :style="{gridTemplateRows: '70px 1fr', maxHeight: '700px', height: '700px'}">
        <div class="fil">
          <Select :width="'200px'" :defaultValue="filCate" @input="filCate=$event" >
            <option :value="null">全部類別</option>
            <option v-for="(category, c) in viewC" :key="`fil-category-${c}`" :value="category">{{category}}</option>
          </Select>
          <searchVue :width="'260px'" :defaultValue="filText" @input="filText=$event"/>
        </div>
        <div class="list">
          <div v-for="(setGroup, sg) in viewf"  :key="`sg-${sg}`" :label="setGroup.category">
            <template v-if="(!filCate||filCate===setGroup.category)">
              <div class="setTitle" v-if="!filText||setGroup.items.filter(({name}) => new RegExp(filText, 'ig').test(name)).length>0" :style="{fontWeight: '900'}">{{setGroup.t==='single'?'-----':'====='}} {{setGroup.category}} {{setGroup.t==='single'?'-----':'====='}}</div>
              <template v-for="({_id, name, id, price}, s) in setGroup.items">
              <div class="setli" :key="`set-${s}`" v-if="!filText||new RegExp(filText, 'ig').test(name)">
                <label :for="_id" :style="{textAlign: 'center', justifyContent:'center'}">
                  <div class="viewExclude" v-if="viewExclude"></div>
                  {{id}} {{name}} <div :style="{marginLeft: 'auto'}">{{formatDollarInt(price)}}</div>
                </label>
              </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </DialogDef2>
    <DialogDef2 :show="warning" :label="'錯誤'" @close="warning=null" :haadBg="'var(--highlight)'">
      <div :style="{fontSize: '24px', padding: '40px 50px'}">{{warning}}</div>
    </DialogDef2>
    <comfirmVue :show="!!deleteItem"  v-if="!!deleteItem" :label="'確認刪除'" :text='`確定要刪除"${deleteItem.name}"嗎?`' @confirm="del(deleteItem._id, deleteItem.index)" @cancel="deleteItem=null"/>
  </div>
</template>

<script>
import Select from '../../components/select.vue'
import RBtn from '../../components/btn/round.vue'
import SaveBtn from '../../components/btn/save.vue'
import AddBtn from '../../components/btn/sqr40016.vue'
import DelBtn from '../../components/btn/del.vue'
import EditBtn from '../../components/btn/edit.vue'
import DateInput from '../../components/input/dateRange.vue'
import NormalInput from '../../components/input/normal.vue'
// import Btns3 from '../../components/btn/btnsx3.vue'
import Btns from '../../components/btn/btns.vue'
import RadioTop from '../../components/radio/r1.vue'
import Table from '../../components/tables/t2_drag.vue'
import { getapi, putapi, deleteapi, postapi } from '../../store/fetch'
import searchVue from '../../components/input/search.vue'
import CheckBox from '../../components/checkbox/checkbox.vue'
import switchVue from '../../components/radio/switch.vue'
import { mapState } from 'vuex'
export default {
  components: {
    Select,
    searchVue,
    AddBtn,
    Table,
    RadioTop,
    Btns,
    SaveBtn,
    // Btns3,
    NormalInput,
    DateInput,
    DelBtn,
    EditBtn,
    RBtn,
    CheckBox,
    switchVue
  },
  data () {
    return {
      warning: null,
      deleteItem: null,
      editRange: false,
      area: null,
      draggable: false,
      filText: null,
      filCate: null,
      addproduct: false,
      specifys: [],
      filter: '全部',
      rows: [],
      store: [],
      mode: '滿額折抵',
      exclude: true,
      name: null,
      cond: null,
      disc: null,
      specify: [],
      spec: null,
      range: {
        start: null,
        end: null
      },
      id: null,
      Sets: [],
      edit: false,
      viewExclude: false,
      editERP: false,
      auto: false,
      view: [],
      tags: [],
      vipTags: [],
      vip: null
    }
  },
  computed: {
    sorted () {
      return this.rows.map(e => e._id)
    },
    products () {
      return [].concat(...this.Sets.map(e => e.items))
    },
    viewf () {
      const sets = JSON.parse(JSON.stringify(this.Sets))
      const view = this.view.map(e => e._id)
      return sets.map(e => {
        return {
          ...e,
          items: e.items.filter(it => view.includes(it._id))
        }
      }).filter(e => e.items.length > 0)
    },
    viewC () {
      const sets = JSON.parse(JSON.stringify(this.Sets))
      const view = this.view.map(e => e._id)
      return sets.map(e => {
        return {
          ...e,
          items: e.items.filter(it => view.includes(it._id))
        }
      }).filter(e => e.items.length > 0).map(e => e.category)
    },
    ...mapState({
      restaurants: 'restaurants'
    })
  },
  watch: {
    area () {
      this.getdata()
    },
    filter () {
      this.getdata()
    }
  },
  async mounted () {
    this.Sets = await getapi('rest_product/category')
    await this.getdata()
    this.vipTags = await getapi('users/tagslist')
  },
  methods: {
    async saveOnline (id, online, index) {
      const r = await postapi(`discount/${id}`, { online })
      this.rows.splice(index, 1, r)
    },
    updateRange ({ start, end }) {
      if (start && end) {
        this.range = { start, end }
        this.editRange = false
      } else {
        this.range = { start, end }
      }
    },
    status ({ startTime, expireTime, fixed, disc }) {
      if (!fixed && !disc) {
        return '禮券範例'
      }
      return (
        this.moment().isBetween(this.moment(startTime), this.moment(expireTime)) ? '進行中' : this.moment().isAfter(this.moment(expireTime)) ? '過期' : '未來'
      )
    },
    async getdata () {
      const r = await getapi(this.area ? `discount/${this.area}?type=${this.filter}` : `discount?type=${this.filter}`)
      this.rows = r
    },
    setItem ({ _id, name, mode, cond, disc, exclude, startTime, expireTime, specify, specify_set: specifys, store, target_tags, auto }) {
      console.log(_id, name, mode, cond, disc, exclude)
      switch (mode) {
        case 1:
          this.mode = '滿額折抵'
          break
        case 2:
          this.mode = '滿額折抵(累進)'
          break
        case 3:
          this.mode = '滿額折扣'
          break
        case 4:
          this.mode = '指定商品折抵'
          break
        case 5:
          this.mode = '指定商品折扣'
          break
        case 7:
          this.mode = '全部指定商品折抵'
          break
      }
      this.id = _id
      this.cond = cond ? parseInt(cond) : 0
      this.disc = disc ? parseInt(disc) : 0
      this.range.start = this.moment(startTime).format('yyyy-MM-DD')
      this.range.end = this.moment(expireTime).format('yyyy-MM-DD')
      this.name = name
      this.exclude = exclude
      this.tags = (target_tags || [])
      this.auto = auto
      this.store = store || []
      this.specify = [...(specify.map(e => { return { ...e, t: 'single' } }) || []), ...(specifys.map(e => { return { ...e, t: 'set' } }) || [])].map(e => e._id)
      this.edit = true
    },
    setItemERP (item) {
      const { _id, store, name, disc, startTime, expireTime, fixed } = item
      this.id = (!fixed && !disc) ? null : _id
      this.name = name
      this.disc = disc
      this.range.start = this.moment(startTime).format('yyyy-MM-DD')
      this.range.end = this.moment(expireTime).format('yyyy-MM-DD')
      this.store = store || []
      this.editERP = item
    },
    clear () {
      this.spec = null
      this.specify = []
      this.mode = '滿額折抵'
      this.name = null
      this.id = null
      this.cond = null
      this.exclude = true
      this.store = []
      this.disc = null
      this.range.start = null
      this.range.end = null
      this.edit = false
      this.editRange = false
      this.editERP = null
    },
    async add () {
      function getmode (mstr) {
        switch (mstr) {
          case '滿額折抵':
            return 1
          case '滿額折抵(累進)':
            return 2
          case '全部指定商品折抵':
            return 7
          case '指定商品折扣':
            return 5
          case '指定商品折抵':
            return 4
          default:
            return 3
        }
      }
      const mode = getmode(this.mode)
      const invalid = []
      if (!this.name) {
        invalid.push('折扣名稱')
      }
      if (mode <= 3) {
        if (!this.cond || isNaN(this.cond)) {
          invalid.push('滿額金額')
        }
        if (!this.disc || isNaN(this.disc)) {
          invalid.push('折扣折抵金額')
        }
      }
      if (mode > 3) {
        if (!this.disc || isNaN(this.disc)) {
          invalid.push('折扣折抵金額')
        }
      }
      if (!this.range.start || !this.range.end) {
        invalid.push('期限')
      }
      if (!this.store || this.store.length === 0) {
        invalid.push('適用區域')
      }
      if (invalid.length > 0) {
        this.warning = invalid.join('、') + '必填'
        return false
      }
      const body = {
        auto: this.auto,
        mode: mode,
        name: this.name,
        cond: this.cond,
        disc: this.disc,
        store: this.store,
        startTime: this.moment(this.range.start).startOf('day').toISOString(),
        expireTime: this.moment(this.range.end).endOf('day').toISOString()
      }
      if (this.auto) {
        body.target_tags = this.tags.filter(e => e)
      }
      if (mode === 4 || mode === 5 || mode === 7) {
        body.specify = this.products.filter(e => this.specify.includes(e._id) && e.t === 'single').map(e => e._id).filter(e => e)
        body.specify_set = this.products.filter(e => this.specify.includes(e._id) && e.t === 'set').map(e => e._id).filter(e => e)
        body.exclude = this.exclude
      } else {
        body.specify = []
        body.specify_set = []
        body.exclude = false
      }
      console.log('add', body)
      const r = await putapi('discount', body)
      if (r) {
        await this.getdata()
        this.clear()
      }
    },
    async updateERP () {
      if (!this.disc) {
        this.$store.commit('setWarning', '金額條件為必填')
        return false
      }
      const ref = JSON.parse(JSON.stringify(this.editERP))
      delete ref.updateTime
      delete ref.startTime
      delete ref.expireTime
      delete ref.specify
      delete ref.specify_set
      delete ref.store
      delete ref._id
      delete ref.__v
      const body = {
        ...ref,
        name: this.name,
        store: this.store,
        startTime: this.moment(this.range.start).startOf('day').toISOString(),
        expireTime: this.moment(this.range.end).endOf('day').toISOString()
      }
      const r = await postapi(`discount/${this.id}`, body)
      if (r) {
        await this.getdata()
        this.clear()
      }
    },
    async addERP () {
      if (!this.disc) {
        this.warning = '金額為必填'
        return false
      }
      const ref = JSON.parse(JSON.stringify(this.editERP))
      delete ref.updateTime
      delete ref.startTime
      delete ref.expireTime
      delete ref.specify
      delete ref.specify_set
      delete ref.store
      delete ref._id
      delete ref.__v
      const body = {
        ...ref,
        disc: this.disc,
        name: this.name,
        store: this.store,
        startTime: this.moment(this.range.start).startOf('day').toISOString(),
        expireTime: this.moment(this.range.end).endOf('day').toISOString()
      }
      const r = await putapi('discount', body)
      if (r) {
        await this.getdata()
        this.clear()
      }
    },
    async del (id, index) {
      const r = await deleteapi(`discount/${id}`)
      if (r) {
        this.rows.splice(index, 1)
        this.deleteItem = null
      }
    },
    async update () {
      function getmode (mstr) {
        switch (mstr) {
          case '滿額折抵':
            return 1
          case '滿額折抵(累進)':
            return 2
          case '全部指定商品折抵':
            return 7
          case '指定商品折扣':
            return 5
          case '指定商品折抵':
            return 4
          default:
            return 3
        }
      }
      const mode = getmode(this.mode)
      const invalid = []
      if (!this.name) {
        invalid.push('折扣名稱')
      }
      if (mode <= 3) {
        if (!this.cond || isNaN(this.cond)) {
          invalid.push('滿額金額')
        }
        if (!this.disc || isNaN(this.disc)) {
          invalid.push('折扣折抵金額')
        }
      }
      if (mode > 3) {
        if (!this.disc || isNaN(this.disc)) {
          invalid.push('折扣折抵金額')
        }
      }
      if (!this.range.start || !this.range.end) {
        invalid.push('期限')
      }
      if (!this.store || this.store.length === 0) {
        invalid.push('適用區域')
      }
      if (invalid.length > 0) {
        this.$store.commit('setWarning', invalid.join('、') + '必填')
        return false
      }
      const body = {
        auto: this.auto,
        mode: mode,
        name: this.name,
        store: this.store,
        cond: this.cond,
        disc: this.disc,
        startTime: this.moment(this.range.start).startOf('day').toISOString(),
        expireTime: this.moment(this.range.end).endOf('day').toISOString()
      }
      if (this.auto) {
        body.target_tags = this.tags
      }
      if (mode === 4 || mode === 5 || mode === 7) {
        body.specify = this.products.filter(e => this.specify.includes(e._id) && e.t === 'single').map(e => e._id).filter(e => e)
        body.specify_set = this.products.filter(e => this.specify.includes(e._id) && e.t === 'set').map(e => e._id).filter(e => e)
        body.exclude = this.exclude
      } else {
        body.specify = []
        body.specify_set = []
        body.exclude = false
      }
      const r = await postapi(`discount/${this.id}`, body)
      if (r) {
        await this.getdata()
        this.clear()
      }
    },
    async saveSort () {
      const body = { items: this.sorted }
      if (this.area) {
        body.store = this.area
      }
      const r = await postapi('discount/sort', body)
      if (r) {
        this.draggable = false
        await this.getdata()
      }
    }
  }

}
</script>
<style lang="scss">
.leftRadio {
  input[type=radio] {
    background-color: #FFFFFF;
    border: 1px solid var(--color-pri);
    color: var(--color-pri);
    &:checked {
      background-color: var(--color-pri);
      color: #FFFFFF;
    }
  }
}
.editDiscount {
    #setDateRange-wrapper {
      width: 394px!important;
      border: 1px solid #CACACA;
    }
    #setDateRange-input {
      border: none!important;
    }
    input[type=text][name=searchText] {
      height: 44px;
    }
}
</style>
<style lang="scss" scoped>
button.pos {
  margin: auto;
  width: 40px;
  height: 40px;
  background-color: #CACACA;
  mask-image: url(/svg/status/cloudeE.svg);
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
  &.able {
    background-color: var(--color-pri);
    mask-image: url(/svg/status/cloude.svg);
  }
}
.auto {
  width: 40px;
  height: 40px;
  mask-image: url(/svg/btn/checkmark.svg);
  background-color: var(--highlight);
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: 26px;
}
.note {
  width: 55px!important;
  height: 30px;
  background-image: url(/remark.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}
.selectAll {
  color: #FFF;
  text-align: center;
  font-family: Noto Sans TC;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.6px;
  background-color: var(--highlight);
  display: flex;
  height: 30px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 69px;
  border-radius: 3px;
  position: absolute;
  left: 0;
}
.fil {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 31px 10px 26px;
  background: #E9F5FC;
}
.list {
  overflow-y: auto;
  margin-inline: 5px;
  padding-inline: 26px;
}
.pointingProduct {
  display: grid;
  grid-template-rows: 70px 1fr 70px;
  gap: 10px;
  max-height: 700px;
}
.specitem {
  padding: 0px 8px;
  border-radius: 3px;
  border: 1px solid var(--color-pri);
  color: var(--color-pri);
  font-size: 18px;
  height: 50px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  &.exclude {
    &::before {
      content: '';
      display: inline;
      background-color: var(--highlight);
      width: 20px;
      height: 20px;
      mask-image: url(/svg/btn/close.svg);
      mask-size: 20px;
      margin-right: 5px;
    }
  }
  &.set {
    background-color: var(--color-pri);
    color: #FFFFFF;
  }
}
.viewExclude {
  background-color: var(--highlight);
  width: 20px;
  height: 20px;
  mask-image: url(/svg/btn/close.svg);
  mask-size: 20px;
  margin-right: 5px;
}
.setTitle {
  font-size: 20px;
  letter-spacing: .3em;
  position: relative;
}
.setli {
  width: 100%;
  label {
    width: 100%;
    display: inline-flex;
    gap: 15px;
    font-size: 20px;
    accent-color: var(--color-pri);
    height: 65px;
    align-items: center;
    color: #787878;
    div.checkbox {
      width: 30px;
      height: 30px;
      background-color: #FFFFFF;
      border: 1px solid var(--color-pri);
      border-radius: 5px;
      &.checked {
        background-color: var(--color-pri);
      }
      input[type=checkbox] {
        appearance: none;
        width: 28px;
        height: 28px;
        background-color: transparent;
        &:checked {
          background-color: #FFFFFF;
          mask-image: url(/svg/checkbox/checkmark.svg);
          mask-position: center;
          mask-repeat: no-repeat;
        }
      }
      &.exclude {
        background-color: #e5e5e5;
        background-image: none;
        mask-image: url(/svg/btn/close.svg);
        mask-position: center;
        mask-size: 20px;
        mask-repeat: no-repeat;
        input[type=checkbox] { display: none; }
      }
      &.exclude.checked {
        background-color: var(--highlight);
        background-image: none;
        mask-image: url(/svg/btn/close.svg);
        mask-position: center;
        mask-size: 20px;
        mask-repeat: no-repeat;
        input[type=checkbox] { display: none; }
      }
    }
  }
}
.leftHead {
  font-weight: 500;
  font-size: 24px;
  line-height: 150%;
  letter-spacing: 0.05em;
  color: var(--color-pri);
}
.field {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  margin-top: 20px;
  &>div:nth-child(1) {
    white-space: nowrap;
    height: 40px;
    line-height: 40px;
    font-weight: 400;
    font-size: 18px;
    text-align: right;
    letter-spacing: 0.1em;
    color: #787878;
    display: block;
    width: 82px;
  }
  span {
    font-weight: 400;
    font-size: 20px;
    line-height: 26px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1em;
    color: #6D6D6D;
  }
  textarea {
    width: 394px;
    height: 120px;
    font-size: 16px;
    letter-spacing: .05em;
    border: 1px solid #959595;
    border-radius: 5px;
    padding: 8px 16px;
  }
  &>div:nth-child(2) {
    display: flex;
    align-items: center;
    font-size: 20px;
    height: 100%;
    min-height: 40px;
    // gap: 10px;
  }
}
.left {
  padding: 30px 70px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
}
.right {
  display: grid;
  grid-template-rows: 70px calc(100% - 70px);
  grid-template-columns: 100%;
  &>div:nth-child(1) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 32px;
    padding-inline: 46px;
    font-weight: 500;
    font-size: 24px;
    line-height: 150%;
    letter-spacing: 0.05em;
    color: var(--color-pri);
  }
  &>div{
    overflow-y: auto;
  }
}
.tags {
  display: flex;
  flex-direction: column;
  align-items: flex-start!important;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  .tagsList {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 15px;
    flex-wrap: wrap;
    &>div {
      width: fit-content;
      padding: 5px 10px ;
      border-radius: 3px;
      text-align: start;
      border: 1px solid var(--color-pri);
      color: var(--color-pri);
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      .close {
        width: 20px;
        height: 20px;
        mask-image: url(/svg/btn/close.svg);
        background-color: #CACACA;
        mask-repeat: no-repeat;
        mask-position: center;
        mask-size: 20px;
      }
    }
  }
  .tagBtns {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  button.add {
    border-radius: 3px;
    width: 40px;
    height: 40px;
    background-color: var(--color-pri);
    margin-left: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    &>div{
      background-color: #FFFFFF;
      mask-image: url(/svg/btn/add.svg);
      width: 26px;
      height: 26px;
      mask-size: contain;
      mask-position: center;
      mask-repeat: no-repeat;
    }
  }
}
</style>
